import { BrowserRouter, Routes, Route } from "react-router-dom";
import AppHeader from "./AppHeader";
import PopularScreen from "../popular";
import SearchScreen from "../search";
import WatchListScreen from "../watchlist";
import FavoritesScreen from "../favorites";
import MovieDetailPage from "../detail";
import TopRatedScreen from "../top-rated";
import UpcomingScreen from "../upcoming";

import IOSInstallPrompt from "../../components/IOSInstallPrompt";
import { Toast } from "../../components/common/Toast";
import { ShareDialog } from "../../components/common/ShareDialog";

export default function Drawer() {
  return (
    <BrowserRouter>
      <AppHeader>
        <Routes>
          <Route path="/" element={<PopularScreen />} />
          <Route path="/top-rated" element={<TopRatedScreen />} />
          <Route path="/upcoming" element={<UpcomingScreen />} />
          <Route path="/search" element={<SearchScreen />} />
          <Route path="/watchlist" element={<WatchListScreen />} />
          <Route path="/favourites" element={<FavoritesScreen />} />
          <Route path="/detail/:id" element={<MovieDetailPage />} />
        </Routes>
      </AppHeader>
      <IOSInstallPrompt />
      <Toast />
      <ShareDialog />
    </BrowserRouter>
  );
}
